<template>
  <div :class="['filter-container filter-container-boolean flex-row', dbOptionHeight]">
    <div class="filter-op">
      <ms-validate ref="validateObserver">
        <menu-wrapper>
          <template #menu-button="{ toggleMenu }">
            <button tabindex="-1" @click="toggleMenu" :class="['btn-filter-operator', dbOptionHeight]">
              <div :class="['icon20', nativeFilterIconClass]" :title="tooltipIcon"></div>
            </button>
          </template>
          <template #menu-content>
            <template v-for="(item, i) in filterOperators" :key="i">
              <menu-item
                class="filter-operator-item"
                :class="item.enumValue === operatorValue ? 'active' : ''"
                @menu-item-click="filterOperatorItemClick(item)"
                :icon="['icon24', item.icon]"
                >{{ item?.enumText }}</menu-item
              >
            </template>
          </template>
        </menu-wrapper>
      </ms-validate>
    </div>
    <div class="filter-value flex flex-center filter-checkbox">
      <ms-checkbox
        v-model="filterValue"
        @change="filterHeaderHandle({ operator: operatorValue, value: filterValue })"
      />
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import msValidate from '@/components/validate/MsValidate.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';

export default defineComponent({
  name: 'MsThOptionBoolean',
  extends: msThOptionBase,
  components: {
    msValidate,
    MenuItem,
    MenuWrapper,
  },
  props: {
    dbOptionHeight: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const {
      nativeFilterIconClass,
      tooltipIcon,
      operatorValue,
      filterOperators,
      filterHeaderHandle,
      removeFilter,
      filterValue,
      filterOperatorItemClick,
    } = setup(props, {
      emit,
    });

    //Hooks

    return {
      nativeFilterIconClass,
      tooltipIcon,
      operatorValue,
      filterOperators,
      filterValue,
      filterHeaderHandle,
      removeFilter,
      filterOperatorItemClick,
    };
  },
});
</script>
<style lang="scss">
.ms-th-filter {
  .filter-container-boolean {
    display: flex;
    justify-content: center;
  }
}
.filter-checkbox {
  .ms-checkbox {
    margin-right: 29px !important;
  }
}
</style>
